module.exports = __webpack_public_path__ + "fonts/Inter-Bold.3e3cb90.ttf";